import { useTranslation } from "react-i18next";
import { CountrySelector } from "@/features/country-select";
import useAuthStore from "@/store/use-auth-store";
import { usePersonaSetup } from "../hooks/use-persona-setup";
import { QuestCard } from "../components/QuestCard";

export const RegionQuest: React.FC = () => {
  const { t } = useTranslation();
  const { saveFields, completeQuest, isSaving } = usePersonaSetup();
  const region = useAuthStore((state) => state.user?.region || "");

  return (
    <QuestCard>
      <div className="mb-5 flex flex-col gap-1">
        <h2 className="text-xl font-bold text-text-primary dark:text-gray-100 sm:text-2xl">
          {t("personaSetup.quests.region.title")}
        </h2>
        <p className="text-sm text-text-tertiary dark:text-gray-400">
          {t("personaSetup.quests.region.description")}
        </p>
      </div>

      <CountrySelector
        id="persona-country"
        value={region}
        disabled={isSaving}
        placeholder={t("settings.profile.countryPlaceholder")}
        onChange={async (value) => {
          if (await saveFields({ region: value })) {
            completeQuest("region");
          }
        }}
      />
    </QuestCard>
  );
};
